import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { Router } from '@vaadin/router';
import '../views/vxv_dashboard'
import '../views/vxv_login'

@customElement('vxa-dashboard')
export class MainApp extends LitElement {
	private router = new Router(this);

	constructor() {
		super();
		this.initRouter();
	}

	private initRouter() {
		this.router.setRoutes([
			{
			  path: '/',
			  action: () => this.checkTokenAndRedirect(),
			},
			{
			  path: '/login',
			  component: 'vxv-login',
			},
			{
				path: '/logout', // New logout route
				action: () => this.handleLogout(),
			},
			{
			  path: '/dashboard',
			  component: 'vxv-dashboard',
			},
			{
				path: '(.*)', // Catch-all for undefined routes
				action: () => Router.go('/'), // Redirect to root path
			  },
		  ]);
	}

	private checkTokenAndRedirect(): void {
		const token = sessionStorage.getItem('token');
		if (token) {
		  	Router.go('/dashboard');
		} else {
		  	Router.go('/login');
		}
	}

	private handleLogout(): void {
		// Remove the token from session storage
		sessionStorage.removeItem('token');
		// Redirect to the login page
		Router.go('/login');
	}

	private disconnectAction() {
		sessionStorage.removeItem('token'); // Remove the token from session storage
		Router.go('/login'); // Redirect to the login page
	}

  	render() {
    	return html`
      		<main>
        		<div id="outlet"></div>
     	 	</main>
			<slot></slot>
    	`;
  	}
}

// View components
@customElement('home-view')
export class HomeView extends LitElement {
  connectedCallback() {
    super.connectedCallback();
    // Additional authentication check when component mounts
    if (!sessionStorage.getItem('token')) {
      const router = new Router();
      Router.go('/');
    }
  }

  render() {
    return html`<h1>Home</h1>`;
  }
}

@customElement('login-view')
export class LoginView extends LitElement {
  render() {
    return html`<h1>Login</h1>`;
  }
}

@customElement('not-found-view')
export class NotFoundView extends LitElement {
  render() {
    return html`<h1>404 Not Found</h1>`;
  }
}

// Add types for the custom elements
declare global {
  interface HTMLElementTagNameMap {
    'vxa-dashboard': MainApp;
    'home-view': HomeView;
    'login-view': LoginView;
    'not-found-view': NotFoundView;
  }
}